module.exports = __webpack_public_path__ + "img/a113.4e6e4da2.png";